/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")




export interface API54244Req {
  
  /** (Long) */
  taskId?: string;
    
};



export interface API54244Res {
  /** 创建任务权限  */
  create?: boolean;
  /** 浏览任务权限  */
  read?: boolean;
  /** 编辑任务权限  */
  edit?: boolean;
  /** 删除任务权限  */
  delete?: boolean;
  /** 下载任务文件的权限  */
  download?: boolean;
  /** 创建子任务权限  */
  createSubTask?: boolean;
  /** 反馈任务权限  */
  feedBack?: boolean;
  /** 放弃任务权限  */
  refuse?: boolean;
  /** 转交任务权限  */
  transfer?: boolean;
  /** 完成任务按钮  */
  finish?: boolean;
  /** 催办任务权限  */
  notify?: boolean;
  
};


// 54244 权限接口

export interface IUseGetAPI54244Return {
  /** 权限接口: 接口请求状态 */
  isAPI54244Loading: boolean;
  /** 权限接口: 接口请求返回数据 */
  dataAPI54244: API54244Res;
  /**  权限接口: 接口数据请求方法 */
  fetchAPI54244Data:  (inputs: API54244Req, config?: YWRequestConfig) => Promise<API54244Res>;
  /** 权限接口: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI54244 = ():IUseGetAPI54244Return => {
  let isMount = true;
  const [isAPI54244Loading, setIsAPI54244Loading] = useState(false);
  const [dataAPI54244, setDataAPI54244] = useState<API54244Res>({} as API54244Res);
  const requestUrl = `${basePath}/team-work/workTask/getTaskPermission`;

  const fetchAPI54244Data = async (inputs: API54244Req, config?: YWRequestConfig): Promise<API54244Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API54244Req>) || {}) as API54244Req;
    
  
    if ( isMount ) {
      setIsAPI54244Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API54244Res>(`${basePath}/team-work/workTask/getTaskPermission?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI54244(res || {} as API54244Res);
        setIsAPI54244Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI54244Loading(false);
      }
      return false as unknown as API54244Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI54244Loading,
    dataAPI54244,
    fetchAPI54244Data,
    requestUrl,
  }
}

